import React from 'react';
import ReactPlayer from 'react-player'
import GenericModal from '../../../shared/components/modals/generic-modal/generic-modal'
import pushEventDataLayer from '../../../utils/pushEventDataLayer'
import './modal-player.scss'

export default function ModalPlayer({ src = '', setOpen }) {
  const handleCloseModalVideo = () => {
    setOpen(false)
    pushEventDataLayer(
      'Interacciones - Video',
      'Cur-v',
      'Reproducir video',
      `${durationVideoWatched}`
    )
  }
  let durationVideoWatched

  return (
    <GenericModal background={'transparent'}>
      <div className="f-modal-player">
        <div className="f-modal-player-container-btn">
          <button
            className="f-modal-player--btn-close"
            onClick={handleCloseModalVideo}
          >
            X
          </button>
        </div>
        <div className="f-modal-player-container-iframe">
          <ReactPlayer
            className="f-section-banner__video"
            width="100%"
            height="auto"
            url={src}
            controls
            onStart={()=>{
              pushEventDataLayer(
                'Interacciones - Video',
                'Cur-v',
                'Reproducir video',
                '0'
              )
            }}
            onProgress={({ playedSeconds }) => {
              durationVideoWatched = playedSeconds
            }}
          />
        </div>
      </div>
    </GenericModal>
  )
}
